module.exports = __webpack_public_path__ + "img/w6_03.627f4c28.jpg";